import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { errorHttp } from '../models/errorHttp';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError, map } from 'rxjs/operators'
import axios from 'axios';
import * as bcrypt from 'bcryptjs';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

declare var $: any;

@Injectable()
export class UserService {
  public url: string;
  public urlphp: string;
  public token;
  actual = environment.actual;


  retorno: Observable<errorHttp>;


  constructor(
    public http: HttpClient,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) document: any
  ) {
    this.url = environment.entidad[this.actual].urlEndPoint;
    this.urlphp = environment.entidad[this.actual].urlEndPointLegacy;
    this.token = this.GetsessionStorage('token')
    console.log(document.location.href);
    /*if (this.actual == 'fondek') {
      if (document.location.href == 'https://www.kdefon.com/oficina_virtual/lan/') {
        this.url = "https://Apifondekbk.co.kworld.kpmg.com:3054/"
      } else if (document.location.href == 'https://www.kdefon.com/oficina_virtual/ext/') {
        this.url = "https://www.kdefon.com:3054/"
      }
    }*/
  }

  httpGet(path): Observable<any> {
    let token = this.GetsessionStorage('token')
    const bearerToken = `Bearer ${token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + path, httpOptions);
  }

  httpPost(path, data): Observable<any> {
    const json = JSON.stringify(data);
    let token = this.GetsessionStorage('token')
    const bearerToken = `Bearer ${token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + path, json, httpOptions);
  }

  async httpAjax(type, path, data): Promise<any> {
    let token = this.GetsessionStorage('token')
    const bearerToken = `Bearer ${token}`;

    let headers = {
      "Authorization": bearerToken,
      "Access-Control-Allow-Origin": "*",
      "Accept": "application/json, text/plain, */*",
      "Content-Type": "application/json",
    }

    return new Promise((resolve, reject) => {
      if (type == 'POST') {
        axios.post(this.url + path, JSON.stringify(data),{headers}).then(resp => {
          resolve(resp.data)
        }).catch(error =>{
          console.log(error)
          reject('error')
        })
      } else {
        $.ajax({
          url: this.url + path,
          type: type,
          beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", bearerToken)
            xhr.setRequestHeader("Access-Control-Allow-Origin", "*")
            xhr.setRequestHeader("Accept", "application/json, text/plain, */*")
            xhr.setRequestHeader("Content-Type", "application/json")
          },
          success: function (response) {
            resolve(response)
          },
          error: function () {
            reject('error')
          }
        })
      }
    })
  }

  GetsessionStorage(value){
    let resp = ''
    if(sessionStorage.getItem(value)){
      resp = sessionStorage.getItem(value)
    }

    return resp
  }

  SetsessionStorage(value, data){
    sessionStorage.setItem(value, data)
  }

  sanitize(url: string, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(url);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(url);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(url);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(url);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      default:
        return this.sanitizer.bypassSecurityTrustHtml(url);
    }
    //return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  public getIPAddress() {

    return this.http.get('https://api.ipify.org/?format=json');
  }

  getPolizas(): Observable<any> {
    const params = null;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'Polizas/1', params, { headers });
  }

  InsertarToken(user, codasociado, getToken): Observable<any> {
    const datos = { user, codasociado, token: getToken };
    const json = JSON.stringify(datos);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'insertarToken', json, httpOptions);
  }

  UrlSolicitud(user): Observable<any> {
    const datos: any = { datos: user };
    const json = JSON.stringify(datos);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'RetornaUrlTercero/1', params, { headers });
  }


////---------------------DEPRECATED-----------------/////

/*login(user, getToken): Observable<any> {
    user.getToken = getToken;
    const json = JSON.stringify(user);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(this.url + 'login', json, httpOptions);
  }

  getParametros(token): Observable<any> {
    const bearerToken = `Bearer ${token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'parametrosGenerales', httpOptions);
  }

  edadAgno(data) {
    return this.http.post(this.url + 'edadAgno', data);
  }*/

/*guardarFecha(cod): Observable<any>{
    const datos: any = {datos: cod};
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'guardarFecha', JSON.stringify(datos), httpOptions);
  }*/



// ------------------ By Esteban Boada --------------------------------

  /*FormularioActualizacion(): Observable<any>{
    const params = null;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'FormularioActualizacion/1', params, {headers});
  }*/
  /*SelectDinamico(tabla, item1, item2, item3): Observable<any>{

    const datos: any = {tabla, item1, item2, item3};
    const json = JSON.stringify(datos);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'SelectDinamico/1', params, {headers});
  }*/

  /*PrecargaDatos(usuario): Observable<any>{
    const datos: any = { usuario };
    const json = JSON.stringify(datos);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'PrecargaDatos/1', params, {headers});
  }*/

  /*cargarEntidad(): Observable<any>{
    const params = null;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'Entidad/1', params, {headers});
  }*/

  /*imprimirEstado(user, codigo): Observable<any>{
    console.log("Imprimir", user);
    console.log("Imprimir1", codigo);
    user = {'user': user, 'codigo': codigo}
    let json = JSON.stringify(user);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp+'imprimirEstado/1', params, {headers});
  }*/

  /*Enviar(info, cod, ip): Observable<any>{
    info.cod = cod;
    info.Ip = ip;
    const datos: any = {info};
    const json = JSON.stringify(datos);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'Enviar/1', params, {headers});
  }*/

  /*verificaActuProceso(usuario): Observable<any>{
    const datos: any = {datos: usuario};
    const json = JSON.stringify(datos);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'Enproceso/1', params, {headers});
  }*/


  /*InsertarToken(user, codasociado, getToken): Observable<any> {
    const datos = {user, codasociado, token: getToken};
    const json = JSON.stringify(datos);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'InsertarToken/1', params, {headers});
  } */

  /*getConfig() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get(this.url + 'parametrosConfig', httpOptions);
  }

  getParametrosIconos(token): Observable<any> {
    const bearerToken = `Bearer ${token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'parametrosIconos', httpOptions);
  }

  aportes(data): Observable<any> {
    //const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'aportes', data, httpOptions);
  }

  movimientosaportes(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'mvtoaportes/' + data.codaporte + '/' + data.codasociado, httpOptions);
  }

    /*ahorros(data): Observable<any> {
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'ahorros', json, httpOptions);
  }*/

  /*mvtoahorros(codahorro): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'mvtoahorros/' + codahorro, httpOptions);
  }

  cartera(data): Observable<any> {
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'cartera', json, httpOptions);
  }

  cuotasext(data) {
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'cuotasExtra', json, httpOptions);
  }

  mvtocartera(numpagare): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'mvtocartera/' + numpagare, httpOptions);
  }

  /*servicios(data): Observable<any> {
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'servicios', json, httpOptions);
  }*/

  /*codeudor(data): Observable<any> {
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'codeudores', json, httpOptions);
  }*/


  /*aceptaSolicitud(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'aceptaCodeudor', data, httpOptions);
  }*/

  /*verify_patronal(data) {
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'verifyPatronal', json, httpOptions);
  }*/

  /*codeudorAso(data): Observable<any> {
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'codeudoresAso', json, httpOptions);
  }*/

  /*descuentos(codasociado): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'descuentos/' + codasociado, httpOptions);
  }*/

  /*departamentos(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'departamentos', httpOptions);
  }*/

  /*ciudades(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'ciudades', httpOptions);
  }*/

  /*bancos(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'bancos', httpOptions);
  }*/

  /*entidades(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'entidades', httpOptions);
  }*/

  /*tipovinculacion(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'tipovinculacion', httpOptions);
  }*/

  /*cargos(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'cargos', httpOptions);
  }*/

  /*precarga(codasociado): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'precarga/' + codasociado, httpOptions);
  }*/

  /*getDestinoCredito(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'destinoCredito', httpOptions);
  }*/

  /*getFrecuenciaCredito(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'frecuenciasCredito', httpOptions);
  }*/


  /*validarActualizacion(codasociado): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'validarActualizacion/' + codasociado, httpOptions);
  }*/

  /*lineasCredito(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'lineasCredito', httpOptions);
  }*/

  /*plazosCredito(codlin): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'plazosCredito/' + codlin, httpOptions);
  }*/

  /*seguroCredito(codlin): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'listarSeguroCredito/' + codlin, httpOptions);
  }*/

  /*validarCodeudor(nitcodeudor): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'validaCodeudor/' + nitcodeudor, httpOptions);
  }*/

  subirAdjunto(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'upload', data);
  }

  /*guardarSolicitudCredito(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'guardarSolicitudCredito', data, httpOptions);
  }*/

  /*getSolicitudes(codasociado): Observable<any> {
    let token = localStorage.getItem('token');
    const bearerToken = `Bearer ${token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'listarSolicitudes/' + codasociado, httpOptions);
  }*/

  /*getDatosDeudor(codasociado): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'listarDatosFirmaPagare/' + codasociado, httpOptions);
  }*/

  /*getCodeudoresSolicitud(numsol): Observable<any> {
    let token = localStorage.getItem('token');
    const bearerToken = `Bearer ${token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'validarCodeudoresSolicitud/' + numsol, httpOptions);
  }*/

  /*getParametrosAdjuntos(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'parametrosAdjuntos', httpOptions);
  }*/


  /*almacenarDatosGirador(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'almacenarDatosGirador', data, httpOptions);
  }*/

  /*almacenarDatosPagare(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'almacenarDatosPagare', data, httpOptions);
  }*/

  /*firmarPagare(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'firmarPagare', data, httpOptions);
  }*/

  /*firmarPagareCodeudor(data): Observable<any> {
    const json = JSON.stringify(data);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.url + 'procesarFirmaCodeudor/1', params, { headers });
  }*/

  /*comprobarTokenCodeudor(data): Observable<any> {
    const json = JSON.stringify(data);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.url + 'comprobarTokenCodeudor/1', params, { headers });
  }*/

  /*generarTokenPagare(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'generarTokenPagare/', data, httpOptions);
  }*/

  /*comprobarToken(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'validarTokenPagare', data, httpOptions);
  }*/

  /*getSolicitudesCodeudor(codunico): Observable<any> {
    let token = localStorage.getItem('token')
    const bearerToken = `Bearer ${token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'listarSolicitudesCodeudor/' + codunico, httpOptions);
  }*/

  /*getTasa(datos): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'getTasa', datos, httpOptions);
  }*/

  /*simular(datossimulacion): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'realizarSimulacion', datossimulacion, httpOptions);
  }*/

  /*serviciosactivos(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'serviciosActivos', data, httpOptions);
  }*/

  /*mvtoservicios(pagare): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'mvtoservicios/' + pagare, httpOptions);
  }*/

  /*tarjetas(codasociado): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'tarjetaAfinidad/' + codasociado, httpOptions);
  }*/

  /*tarjetasCred(codasociado): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'tarjetaCredito/' + codasociado, httpOptions);
  }*/

  /*mvtotarjetas(codtarjeta): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'mvtoTarjeta/' + codtarjeta, httpOptions);
  }*/

  /*mvtotarjetasCred(codtarjeta): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'mvtoTarjetaCred/' + codtarjeta, httpOptions);
  }*/

  /*trackingSolicitud(numsol): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'trackingSolicitud/' + numsol, httpOptions);
  }*/

  /*plandepagos(user, pagare): Observable<any> {
    user.pagare = pagare;
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };

    return this.http.post(this.url + 'planPagos', user, httpOptions);
  }*/

  /*pagosfuturos(user, pagare, fechaAct): Observable<any> {
    user.pagare = pagare;
    user.fechaAct = fechaAct
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };

    return this.http.post(this.url + 'pagosFuturos', user, httpOptions);
  }*/

  /*change(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'cambiarContrasena', data, httpOptions);
  }*/

  /*register(user): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'register', user, httpOptions);
  }*/

  /*getFrecuenciaSimulador() {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'getFrecuenciaSimulador', httpOptions);
  }*/



  /*reset(user): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'resetPassword', user, httpOptions);
  }*/

  /*getSeguro(codlin) {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'listarSeguroCredito/' + codlin, httpOptions);
  }*/

  /*getSeguroAfiancol() {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'seguroAfiancol', httpOptions);
  }*/

  /*FormularioActualizacion(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'getParamsActualizacion', httpOptions);
  }*/

  /*SelectDinamico(actualizacion, tabla, item1, item2, item3): Observable<any> {
    actualizacion.tabla = tabla
    actualizacion.item1 = item1
    actualizacion.item2 = item2
    actualizacion.item3 = item3
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'selectDinamico', actualizacion, httpOptions);
  }*/

  /*Check(actualizacion, tabla, item1, item2): Observable<any> {
    actualizacion.tabla = tabla
    actualizacion.item1 = item1
    actualizacion.item2 = item2
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'check', actualizacion, httpOptions);
  }*/

  /*PrecargaDatos(user, usuario, cod): Observable<any> {
    user.usuario = usuario
    user.cod = cod
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'precargaDatos', user, httpOptions);
  }*/

  /*ConsultaDocumentos(): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'consultaDocumentos', httpOptions);
  }*/

  /*imprimirEstado(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'estadoCuenta', data, httpOptions);
  }*/

  /*verificaActualizacionIni(data): Observable<any> {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'verificaActualizacionIni', JSON.stringify(data), httpOptions);
  }*/

  /*cargarEntidad(): Observable<any> {
    return this.http.get(this.url + 'cargaEntidad');
  }*/

  /*actAhorro(data, asociado) {
    data.cod = asociado
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'actAhorro', json, httpOptions);
  }*/

  /*actAporte(data, asociado) {
    data.cod = asociado
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'actAporte', json, httpOptions);
  }*/

  /*Enviar(info, cod, ip): Observable<any> {
    info.CodAsociado = cod;
    info.Ip = ip;
    const datos: any = { info };
    const json = JSON.stringify(datos);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'guardaActualizacion', json, httpOptions);
  }*/

  /*verificaActuProceso(usuario): Observable<any> {

    console.log(datos)
    const json = JSON.stringify(datos);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'enproceso', json, httpOptions);
  }*/

  /*docActualizacion(data) {
    const json = JSON.stringify(data);
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.post(this.url + 'docActualizacion', json, httpOptions);
  }*/

  ////////////////////////////////Seguro////////////////////////////////

  /*getParentescos() {
    const bearerToken = `Bearer ${this.token}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: bearerToken
      })
    };
    return this.http.get(this.url + 'getParentescos', httpOptions);
  }*/

  /*guardarFecha(cod): Observable<any> {
    const datos: any = { datos: cod };
    const json = JSON.stringify(datos);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'GuardarFecha/1', params, { headers });
  }*/

  /*campActualiza(usuario): Observable<any> {
    const datos: any = { datos: usuario };
    const json = JSON.stringify(datos);
    const params = 'json=' + json;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(this.urlphp + 'CampanaAct/1', params, { headers });
  }*/
}

